<template>
  <div>
    <slot name="owner" v-if="userType === USER_TYPE.OWNER"></slot>
    <slot name="regular" v-else-if="userType === USER_TYPE.REGULAR"></slot>
  </div>
</template>

<script>
import { USER_TYPE } from '@/constants/user'

/**
 * This component provides a way to conditionally render different components based on user type (i.e owner, regular)
 */
export default {
  name: 'UserTypeBasedRenderer',
  props: ['orgId'],
  components: {},
  data() {
    return {
      USER_TYPE
    }
  },
  computed: {
    userType() {
      const userId = this.$store.getters.user.id
      const orgMembers = this.$store.getters.orgMemberships(this.orgId)
      const user = orgMembers?.find(x => x.userId === userId)
      return user?.type
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
